import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bulk_booking_create_client = _resolveComponent("bulk-booking-create-client")!
  const _component_bulk_booking_create_internal = _resolveComponent("bulk-booking-create-internal")!
  const _component_bulk_booking_create_retail = _resolveComponent("bulk-booking-create-retail")!

  return (_ctx.utilsBulkBooking().permissionClient)
    ? (_openBlock(), _createBlock(_component_bulk_booking_create_client, { key: 0 }))
    : (_ctx.flagsBulkBookingInternal)
      ? (_openBlock(), _createBlock(_component_bulk_booking_create_internal, { key: 1 }))
      : (_openBlock(), _createBlock(_component_bulk_booking_create_retail, { key: 2 }))
}